/**
 * The Tasks screen's phone tabs (`TasksPhoneTabs.tsx`): the table, then
 * the phone calendar's three. Kept apart from the component so the ids
 * can be shared with the panels without a component module exporting
 * anything else.
 */
import { PHONE_TABS, type PhoneTab } from './calendar/phone-model';

export type TasksPhoneTab = 'table' | PhoneTab;

export const TASKS_PHONE_TABS: ReadonlyArray<{ id: TasksPhoneTab; label: string }> = [
  { id: 'table', label: 'Table' },
  ...PHONE_TABS,
];

/** The id of a tab's button, for its panel's `aria-labelledby`. */
export function tasksPhoneTabId(tab: TasksPhoneTab): string {
  return `tasks-tab-${tab}`;
}

/** The id of the panel a tab shows. */
export function tasksPhonePanelId(tab: TasksPhoneTab): string {
  return `tasks-panel-${tab}`;
}
